import { render, staticRenderFns } from "./EmployeeProficiencyCreateOrUpdate.vue?vue&type=template&id=206e4d82&"
import script from "./EmployeeProficiencyCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./EmployeeProficiencyCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports